/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.Confirm = class Confirm {
  constructor(rails, event) {
    this.rails = rails;
    this.event = event;
    this.defaults = {
      modalClass: 'text-center',
      title: 'Are you sure?',
      titleClass: '',
      body: 'This action cannot be undone.',
      bodyClass: '',
      icon: '',
      footerClass: '',
      ok: 'Confirm',
      okClass: 'primary button',
      cancel: 'Cancel',
      cancelClass: 'secondary button'
    };
    if (!this.allowAction(this.event.target)) {
      this.rails.stopEverything(this.event);
    }
  }

  allowAction(element) {
    if (element.getAttribute('data-confirm-modal') === null) {
      return true;
    }

    this.showConfirmationDialog(element);
    return false;
  }

  showConfirmationDialog(element) {
    const _this = this;
    const settings = $.extend({}, this.defaults);
    const elOptions = $(element).data('confirm-modal');

    const option = name => elOptions[name] || settings[name];

    const modal = $(`<div data-reveal \
id=\'confirm-dialog\' \
class=\'reveal ` + option('modalClass') + `\' \
data-animation-in="slide-in-down" \
data-animation-out="slide-out-down">\n \
<h2 data-confirm-title class=\'` + option('titleClass') + `\'></h2>\n \
<div data-confirm-icon></div>\n \
<p data-confirm-body class=\'` + option('bodyClass') + `\'></p>\n \
<div data-confirm-footer class=\'` + option('footerClass') + `\'>\n \
<a data-confirm-cancel class=\'` + option('cancelClass') + `\'></a>\n \
</div>\n \
</div>`);
    const confirmButton =
      $(element).is('a') ? $(element).clone() : $('<a/>');
    confirmButton.removeAttr('data-confirm-modal');
    confirmButton
    .attr('class', option('okClass'))
    .html(option('ok'))
    .on('click', function(e) {
      if ($(this).prop('disabled')) {
        return false;
      }
      $(element).trigger('confirm.reveal', e);
      if ($(element).is('form, :input')) {
        $(this).attr('data-style', 'zoom-in');
        $(this).addClass('disabled');
        $(this).prop('disabled');
        Ladda.create(this).start();
        return $(element).closest('form').removeAttr('data-confirm-modal').submit();
      }
    });
    modal.find('[data-confirm-title]').html(option('title'));
    modal.find('[data-confirm-body]').html(option('body'));
    modal.find('[data-confirm-icon]').html(option('icon'));
    modal.find('[data-confirm-cancel]')
    .html(option('cancel'))
    .on('click', function(e) {
      modal.foundation('close');
      $(element).trigger('cancel.reveal', e);
      return Ladda.stopAll();
    });
    modal.find('[data-confirm-footer]').append(confirmButton);
    return modal
    .appendTo($('body'))
    .foundation()
    .foundation('open')
    .on('closed.fndtn.reveal', e => modal.remove());
  }
};
